import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Modal from 'reactstrap/lib/Modal';
import Button from 'reactstrap/lib/Button';
import { modalMousedownTrackingFix } from 'site-modules/shared/utils/modal-tracking-fix';
import { FeatureStylesList } from 'site-modules/comparator/components/feature-styles-list/feature-styles-list';
import { StyleConfirmDialog } from 'site-modules/comparator/components/style-confirm-dialog/style-confirm-dialog';

import './other-styles-feature-modal.scss';

export function OtherStylesFeatureModal({
  featureName,
  modelName,
  name,
  styleId,
  toggleModal,
  isModalOpened,
  featureCategorySlug,
  featureNameSlug,
  addVehicle,
}) {
  const [chosenStyle, setChosenStyle] = useState();

  const setStyle = useCallback(style => {
    setChosenStyle(style);
  }, []);

  const resetStyle = useCallback(() => {
    setChosenStyle(null);
  }, []);

  const changeVehicle = useCallback(() => {
    if (!chosenStyle) {
      return;
    }

    toggleModal();
    addVehicle(chosenStyle.styleId);
  }, [addVehicle, chosenStyle, toggleModal]);

  return (
    <Modal
      className="other-styles-modal"
      contentClassName="py-3 px-1 px-md-3_5"
      isOpen={isModalOpened}
      toggle={toggleModal}
      onMouseDown={modalMousedownTrackingFix}
      data-tracking-parent="available_on_other_styles"
    >
      <Button
        className="modal-close-btn p-0_25 text-gray-darker size-20 bg-white pos-a top-0 right-0 mt-0_5 me-0_5 mt-md-0_75 me-md-0_75"
        onClick={toggleModal}
      >
        <i className="icon-cross2" aria-hidden />
      </Button>
      <div className={classnames('text-center', { invisible: !!chosenStyle })} aria-hidden={!!chosenStyle}>
        <div className="text-gray-darker heading-4 mb-2">{featureName} is not available in the selected style</div>
        <div className="mb-0_25 text-gray-darker">
          Click on a {modelName} model to replace the {name} in your comparison:
        </div>
        <FeatureStylesList
          styleId={styleId}
          featureCategorySlug={featureCategorySlug}
          featureNameSlug={featureNameSlug}
          chooseStyle={setStyle}
        />
      </div>
      <div
        className={classnames('pos-a center-xy w-100 px-1 px-md-3_5', {
          invisible: !chosenStyle,
        })}
        aria-hidden={!chosenStyle}
      >
        <StyleConfirmDialog style={chosenStyle} onConfirm={changeVehicle} onCancel={resetStyle} />
      </div>
    </Modal>
  );
}

OtherStylesFeatureModal.propTypes = {
  featureName: PropTypes.string.isRequired,
  featureCategorySlug: PropTypes.string.isRequired,
  featureNameSlug: PropTypes.string.isRequired,
  addVehicle: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  isModalOpened: PropTypes.bool.isRequired,
  styleId: PropTypes.string.isRequired,
  modelName: PropTypes.string,
  name: PropTypes.string,
};

OtherStylesFeatureModal.defaultProps = {
  modelName: '',
  name: '',
};
